import { Sheet } from 'react-modal-sheet';
import SheetCloseButton from './SheetCloseButton';
import sheetDesignAsset from '../../../Assets/BOB/v2/bottom-sheet-asset-design.png';
import styles from './BottomSheet.module.css';

type BottomSheetType = {
  isOpen: boolean;
  onClose: () => void;
  onTap: () => void;
  className: string;
  backdrop?: boolean;
  closeButton?: boolean;
  detent?: 'full-height' | 'content-height';
  showSheetCenteredImgDesign?: boolean;
  // Backdrop's default is rgba(0, 0, 0, 0.2) - override to make it lighter
  // (closer to 0) or darker (closer to 1).
  backdropOpacity?: number;
  children: React.ReactNode;
} & React.ComponentProps<typeof Sheet>;

const BottomSheet = ({
  isOpen,
  onClose,
  onTap,
  className,
  closeButton = true,
  detent = 'content-height',
  backdropOpacity = 0.8,
  showSheetCenteredImgDesign = true,
  children,
  ...sheetProps
}: BottomSheetType) => (
  <Sheet
    isOpen={isOpen}
    detent={detent}
    className={className}
    onClose={onClose}
    {...sheetProps}
  >
    <Sheet.Backdrop
      onTap={onTap}
      className={styles.backdrop}
      style={{ '--backdrop-opacity': backdropOpacity } as React.CSSProperties}
    />
    <Sheet.Container>
      {closeButton && <SheetCloseButton onClick={onClose} />}
      <Sheet.Content className={styles.genericSheet}>
        {showSheetCenteredImgDesign && <img
          src={sheetDesignAsset}
          alt='sheet-asset'
          className={styles.sheetAsset}
        />}

        {children}
      </Sheet.Content>
    </Sheet.Container>
  </Sheet>
);

export default BottomSheet;
